import { FC } from "react";
import { DynamicResources, GameResources } from "../types";
import { getValueColor, getResourceSprite } from "../utils/tileOverlayUtils";
import Sprite from "./Sprite";
import { formatNumber } from "../utils/formatting";

export interface TileOverlayDisplayProps {
  x: number;
  y: number;
  screenX: number;
  screenY: number;
  resources: DynamicResources;
  width?: string;
  height?: string;
  label: string;
}

export const TileOverlayDisplay: FC<TileOverlayDisplayProps> = ({
  x,
  y,
  screenX,
  screenY,
  resources,
  label,
  width = "64px",
  height = "104px",
}) => {
  return (
    <div
      className="absolute pointer-events-none z-40"
      data-testid="tile-overlay"
      style={{
        left: `${screenX}px`,
        top: `${screenY}px`,
        width,
        height,
      }}
    >
      <div
        className="bg-black/20 text-white rounded border border-gray-400/80 w-full h-full relative"
        title={`Tile (${x}, ${y}) - ${label}`}
      >
        {/* Title at top - Can extend outside overlay */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 text-center text-xs text-cyan-300 bg-black/70 px-1 py-0.5 whitespace-nowrap z-10">
          {label}
        </div>

        {/* Resources in center */}
        <div className="absolute inset-0 flex flex-col items-center justify-center pt-2">
          {GameResources.map((resource) =>
            resources[resource] !== 0 ? (
              <div
                key={resource}
                className={`flex items-center gap-1 ${getValueColor(resources[resource])} font-bold text-xs leading-none bg-black/60 px-1 py-0 rounded`}
              >
                <Sprite
                  filename="/images/resources_20.png"
                  {...getResourceSprite(resource)}
                  width={20}
                  height={20}
                  className="inline-block"
                />
                <span>{formatNumber(resources[resource], true)}</span>
              </div>
            ) : null,
          )}
        </div>
      </div>
    </div>
  );
};
